<h2 mat-dialog-title>Su cita fue creada exitosamente</h2>
<div mat-dialog-content>
  <p>Le hemos enviado un email con el link su cita y la fecha de la misma</p>
</div>
<div matDialogActions>
  <button mat-raised-button color="banesco" mat-dialog-close>Finalizar</button>
</div>
